// extracted by mini-css-extract-plugin
export default {"tab":"tab--xu31C","text":"text--xu31C","active":"active--xu31C"};